<!-- list -->
<div class="row">
    <div class="col-12">

        <div class="card">
            <div class="card-header">
                <div class="title">{{ 'NOTIFICATION.NOTIFICATION_LIST' | translate }}</div>
                <div class="tools">

                    <button type="button" class="btn btn-primary btn-sm" [disabled]="!checkedCheckBox()" (click)="deleteSelected()">
                        <i class="bi bi bi-trash"></i> {{ 'DELETE_SELECTED' | translate }}
                    </button>
                  
                    <button type="button" class="btn btn-primary btn-sm" (click)="actionWithRolesSettings('')">
                        <i class="bi bi-plus-circle"></i> {{ 'CREATE' | translate }}
                    </button>
                </div>
            </div>

            <div class="card-body">

                <table class="table table-hover">

                    <thead>
                        <tr>
                            <th scope="col" class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_notify_role_all"
                                        id="select_notify_role_all" [checked]="isAllCheckBoxChecked()"
                                        [indeterminate]="checkedButNotAllCheckBox()"
                                        (change)="checkAllCheckBox($event)">
                                    <label class="custom-control-label" for="select_notify_role_all"></label>
                                </div>
                            </th>
                            <th scope="col" class="name">Имя пользователя</th>
                            <th scope="col" class="group">Наименование действия</th>
                            <th scope="col" class="group">Наименование роли</th>
                            <th scope="col" class="group">Дата</th>
                            <th scope="col" class="action">{{ 'ACTION' | translate }}</th>
                        </tr>
                    </thead>

                    <tbody *ngIf="notifications && notifications.length > 0">
                        <tr *ngFor="let notification of notifications; let i = index">
                            <td class="checkbox">
                                <div class="custom-control custom-checkbox">
                                    <input class="custom-control-input" type="checkbox" name="select_notify_role_all{{ i }}"
                                        id="select_notify_role_all{{ i }}" [checked]="notification.checked"
                                        (change)="selectedCheckBox(i, $event)">
                                    <label class="custom-control-label" for="select_notify_role_all{{ i }}"></label>
                                </div>
                            </td>
                            <td class="name">{{notification.username}}</td>
                            <td class="name">{{notification.action_name}}</td>
                            <td class="name">{{notification.role_name}}</td>
                            <td class="name">{{notification.date}}</td>
                            <td class="action">
                                <!-- <button type="button" class="btn btn-light" (click)="actionWithRolesSettings(notification.id)"
                                    placement="top" ngbTooltip="{{ 'EDIT' | translate }}">
                                    <i class="bi bi-pencil-square"></i>
                                </button> -->
                                <button type="button" class="btn btn-light" (click)="onConfirm([notification.id])"
                                    placement="top" ngbTooltip="{{ 'DELETE' | translate }}">
                                    <i class="bi bi bi-trash"></i>
                                </button>
                            </td>
                        </tr>
                    </tbody>
                    <tbody *ngIf="!notifications || notifications.length == 0">
                        <tr>
                            <td *ngIf="loading" class="data-loading" colspan="6">
                                <div>{{ 'LOADING' | translate }}</div>
                            </td>
                            <td *ngIf="!loading" class="data-not-found" colspan="6">
                                <div>{{ 'DATA_NOT_FOUND' | translate }}</div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="card-footer">
                <app-pagination [pageData]="paginationInput" (pageEvent)="pageEvent($event)"></app-pagination>
            </div>
        </div>
    </div>
</div>